import * as z from "zod";

export const createRedoLandmarkGlobalIntegration = {
  name: "createRedoLandmarkGlobalIntegration" as const,
  input: z.object({
    teamId: z.string(),
    username: z.string(),
    password: z.string(),
    shippingLaneRegion: z.string(),
    clientId: z.string(),
  }),
  output: z.null(),
};
